import { Box, Button, Flex, Stack, Text } from "@chakra-ui/react";

const Tokenization = (props) => {
    const { onOpenLoginModal } = props;

    return (
        <Stack align="center" px={{ base: "14px", sm: "10vw" }} >
            <Flex w="100%" maxW="1140px" mb="100px" justifyContent="space-between" fontSize="19px" color="#1C3E64" flexDirection={{ base: "column", xl: "row" }} >
                <Flex w={{ base: "100%", xl: "47%" }} justifyContent='center' alignContent="center">
                    <video
                        title='naruto'
                        src='https://redswan.io/wp-content/uploads/2023/03/phone-animation.mp4'
                        style={{ maxWidth: "522px", width: "100%", backgroundColor: "white" }}

                    />
                </Flex>
                <Box w={{ base: "100%", xl: "45%" }} pt="29px">
                    <Text fontSize="41px" fontWeight="300" pb="20px" borderBottom="1px solid rgba(28, 62, 100, 0.50)">Why Tokenized
                        Commercial Real Estate?
                    </Text>
                    <Text mt="28px" mb="33px">Historically, commercial real estate investment has been stable, lucrative and outperforms the stocks and bonds market in the long term. Real estate is also a perfect hedge against inflation.
                    </Text>
                    <Text mb="33px">
                        Asset Tokenization CRE is using blockchain technology to tokenize assets. We are disrupting the real estate landscape & making it easy for anyone to invest on a global level.
                    </Text>
                    <Text mb="33px">
                        Whether you are a high net worth, institutional or retail investor, Asset Tokenization CRE’s crowdfunding-style investment platform makes it easy for you to start investing in minutes.
                    </Text>
                    <Button
                        _hover={{
                            border: "1px solid #002B5B",
                            color: "#002B5B",
                            bgColor: "white"
                        }}
                        bgColor="#002B5B"
                        color="white"
                        fontSize="20px"
                        p="12px 24px"
                        onClick={onOpenLoginModal}
                    >
                        Get Started Now
                    </Button>
                </Box>

            </Flex>
        </Stack>
    );
}

export default Tokenization;